function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { LocalizationService } from './LocalizationService';
import Component from 'vue-class-component';
import { VueComponent } from '@progress/kendo-vue-common';
/**
 * A Vue component which provides a localization service.
 * Expects a language string as a property of the component.
 */

var LocalizationProvider =
/** @class */
function (_super) {
  __extends(LocalizationProvider, _super);

  function LocalizationProvider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Returns a localization service.
   * The method is suitable for overriding when you
   * implement custom localization behavior.
   */


  LocalizationProvider.prototype.getLocalizationService = function () {
    return new LocalizationService(this.$props.language);
  };
  /**
   * @hidden
   */


  LocalizationProvider.prototype.getChildContext = function () {
    return {
      kendoLocalizationService: this.getLocalizationService()
    };
  };
  /**
   * @hidden
   */
  // @ts-ignore


  LocalizationProvider.prototype.render = function (h) {
    return h("div", [this.$slots.default]);
  };

  LocalizationProvider = __decorate([Component({
    props: {
      language: String
    },
    provide: function provide() {
      // @ts-ignore
      return this.getChildContext();
    }
  })], LocalizationProvider);
  return LocalizationProvider;
}(VueComponent);

export { LocalizationProvider };